import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { FaPlus, FaMinus } from "react-icons/fa";
import parse from 'html-react-parser';
import useFaq from "hooks/useFAQ";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import notify from "../../assets/images/Notification.png";


const Faq = () => {
  const { faqData } = useFaq();
  const [activeKey, setActiveKey] = React.useState(null); // Initialize with null

  const handleToggle = (eventKey) => {
    setActiveKey(eventKey === activeKey ? null : eventKey);
  };

  const renderToggleIcon = (eventKey) => {
    return eventKey === activeKey ? <FaMinus /> : <FaPlus />;
  };

  return (
    <div className="container-box faq">
      <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
        <h2>
          FAQ
        </h2>
        <Nav.Link as={Link} to="/notification" href="/notification">
          <div type="" className=" position-relative">
            <img src={notify} alt="" />
            <span className="position-absolute  badge-custom   rounded-circle">
              <span className="visually-hidden">New alerts</span>
            </span>
          </div>
        </Nav.Link>
      </div>
      <div className="outer-white job-details-page px-3">
        <Accordion activeKey={activeKey}>
          {faqData?.faqs?.map((item, i) => (
            <Accordion.Item key={i} eventKey={i.toString()}> {/* Use i as eventKey */}
              <Accordion.Header onClick={() => handleToggle(i.toString())}> {/* Pass i as eventKey */}
                {item?.title}
                <div className="icon-faq">{renderToggleIcon(i.toString())}</div>
              </Accordion.Header>
              <Accordion.Body>
                {parse(item?.description)}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default Faq;
